<div class="flex h-full flex-col">
  @if (loading()) {
    <!-- Loading spinner -->
    <div class="flex h-32 items-center justify-center">
      <mat-spinner diameter="40" />
    </div>
  } @else if (data().length === 0) {
    <!-- Empty state -->
    <div class="flex h-32 flex-col items-center justify-center text-gray-500">
      <mat-icon class="mb-2 text-4xl">folder_open</mat-icon>
      <span>{{ 'routing.SUB_ROUTE_PARTNERS.UNASSIGNED_GROUPED.EMPTY' | t }}</span>
    </div>
  } @else {
    <!-- Cards con scroll infinito -->
    <div class="groups-list flex-1 overflow-auto p-2" (scroll)="onScroll($event)">
      @for (group of data(); track group._id) {
        <app-group-card [group]="group" (openDetail)="openGroupDetailModal($event)" />
      }

      <!-- Loading more indicator -->
      @if (loadingMore()) {
        <div class="flex items-center justify-center py-4">
          <mat-spinner diameter="24" />
          <span class="ml-2 text-xs text-gray-500">{{ 'routing.SUB_ROUTE_PARTNERS.UNASSIGNED_GROUPED.LOADING_MORE' | t }}</span>
        </div>
      }
    </div>
  }
</div>
